import React from 'react';
import { unescapeEmojis } from 'modules/codeless-events/utils/stringUtils';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import styles from './eventRule.module.scss';

export const EventRule = ({ event }) => {
    const isButtonClicks = event.type === CONVERSION_TYPE.EVENT_BASED;
    const urlEvent = event.urlEvent || event.condition?.value || '';
    const includeInTotalConversions = event.includeInTotalConversions || false;
    const conversionName = event.conversionName || '';

    const getButtonClicksMessage = () => {
        const trackedElements = event.trackedElements || [];
        const displayTexts = trackedElements.map(element => unescapeEmojis(element.displayText));

        if (displayTexts.length === 0) {
            return event.eventName || '';
        }

        const formattedButtons = displayTexts.map((text, index) => (
            <span key={index}>
                <strong>'{text}'</strong>
                {index < displayTexts.length - 1 && <span className={styles['or-separator']}> OR </span>}
            </span>
        ));

        return (
            <FormattedMessage
                id="codeless.event.rule.button.clicks"
                defaultMessage="When someone clicks on: {buttons} the event will trigger."
                values={{ buttons: formattedButtons }}
            />
        );
    };

    const getTriggerRuleContent = () => {
        return isButtonClicks ? (
            getButtonClicksMessage()
        ) : (
            <FormattedMessage
                id="codeless.event.rule.url.contains"
                defaultMessage="When URL contains: <strong>`{url}`</strong>"
                values={{ url: urlEvent }}
            />
        );
    };

    return (
        <div className={styles['grid-container']}>
            <div className={styles['grid-row']}>
                <div className={styles['grid-label']}>
                    <FormattedMessage id="codeless.event.rule.trigger.title" defaultMessage="Trigger rule" />
                </div>
                <div className={styles['grid-value']}>{getTriggerRuleContent()}</div>
            </div>

            <div className={styles['grid-row']}>
                <div className={styles['grid-label']}>
                    <FormattedMessage id="codeless.event.conversion.name" defaultMessage="Conversion name" />
                </div>
                <div className={styles['grid-value']}>{conversionName}</div>
            </div>

            <div className={styles['grid-row']}>
                <div className={styles['grid-label']}>
                    <FormattedMessage
                        id="codeless.event.status.include.conversions"
                        defaultMessage="Include in total conversions"
                    />
                </div>
                <div className={styles['grid-value']}>
                    <FormattedMessage
                        id={`codeless.event.status.${includeInTotalConversions ? 'on' : 'off'}`}
                        defaultMessage={includeInTotalConversions ? 'On' : 'Off'}
                    />
                </div>
            </div>
        </div>
    );
};
